/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AccordianContent } from '../../models/accordian-content';
import { AccordianContentApiRespModel } from '../../models/accordian-content-api-resp-model';

export interface ApiMasterAccordianContentAddPost$Params {
      body?: AccordianContent
}

export function apiMasterAccordianContentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterAccordianContentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AccordianContentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterAccordianContentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AccordianContentApiRespModel>;
    })
  );
}

apiMasterAccordianContentAddPost.PATH = '/api/Master/AccordianContent/Add';
